import { TabDesign, TabLayout, Tabs, Theme } from '@nextgen-web-framework/all';
import { useState, useEffect } from 'react';
import TimelineCard from './TimelineCard/TimelineCard';
import type { AwardsAndAccoladesTimelinesProps } from './types/propsTypes';
import styles from './AwardsAndAccoladesTimelines.module.scss';

const { PURPLE } = Theme;
const { HORIZONTAL } = TabLayout;
const { TRANSPARENT } = TabDesign;
const AwardsAndAccoladesTimelines = (props: AwardsAndAccoladesTimelinesProps) => {
  const { year, timelines } = props;
  const currentIndex = timelines?.findIndex((tab) => tab.title === year);
  const [index, setIndex] = useState(currentIndex);
  useEffect(() => {
    setIndex(currentIndex);
  }, [currentIndex]);
  return (
    <div data-testid={'timelines-tabs-test-id'}>
      <div className={styles['awards-timelines-tabs-scroller']}>
        <Tabs
          theme={PURPLE}
          layout={HORIZONTAL}
          selectedTab={index}
          onTabClick={(index, currentYear) => {
            props?.callBack?.(currentYear);
            setIndex(index);
          }}
          design={TRANSPARENT}
          tabList={timelines}
        />
      </div>
      <div className={styles['awards-timelines-container']}>
        {props.timelineItems[index]?.data?.map((awardData) => (
          <TimelineCard
            key={`${awardData.title}${awardData.description}`}
            alt_text={awardData.images[0].alt_text}
            url={awardData.images[0].image.url}
            description={awardData.description}
            title={awardData.title}
          />
        ))}
      </div>
    </div>
  );
};

export default AwardsAndAccoladesTimelines;
export type { AwardsAndAccoladesTimelinesProps };
